<template>
  <div>
    <h1>Отзывы</h1>
    <div class="flex-row">
      <div class="flex-col">
        <Datepicker
          v-model="datepickerPeriod"
          format="{
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            }"
          lang="ru"
          placeholder="Выбрать период"
          range
          @change="updatePeriodFromDatePicker"
        />
      </div>
      <div class="flex-col">
        <div class="form-group">
          <label for="region-select">Регион</label>
          <select
            id="region-select"
            v-model="region"
            class="form-control region-select"
            required
          >
            <option
              v-for="(item, index) in regions"
              :key="index"
              :value="item.id"
              :selected="region === item.id"
            >
              {{ item.title }}
            </option>
          </select>
        </div>
      </div>
      <div class="flex-col">
        <div class="form-group">
          <label for="">Поисковая система</label>
          <fieldset id="search-engine-group">
            <div>
              <input
                v-model="searchEngine"
                type="radio"
                :value="'y'"
                name="search-engine-group"
                class="from-control"
              >
              <span>Яндекс</span>
            </div>
            <div>
              <input
                v-model="searchEngine"
                type="radio"
                :value="'g'"
                name="search-engine-group"
                class="from-control"
              >
              <span>Google</span>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
    <h4 class="text-bold">
      Динамика репутационной выдачи* в поисковых системах по проекту
    </h4>
    <p class="text-muted">
      показатели изменений репутационной выдачи за счет размещения новых положительных упоминаний о Вашей компании
    </p>
    <c-box-chart
      :axis-ticks-y-begins-at-zero="chart.axisTicksYBeginAtZero"
      :color="chart.color"
      :data="chart.chartData"
      :height="360"
      :loading="isChartLoading"
      :step-y="chart.stepY"
      :type="chart.type"
    />
    <h4 class="text-bold">
      Динамика положительных отзывов в ТОП30* в поисковой системе Яндекс
    </h4>
    <p class="text-muted">
      показатели изменений репутационной выдачи за счет размещения новых положительных упоминаний о Вашей компании
    </p>
    <c-box-table
      v-if="!isTableLoading"
      :data="table"
    />
    <c-box v-else>
      <no-data text="Нет данных" />
      <br>
      <c-spinner />
    </c-box>
  </div>
</template>

<script>
import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import '../../../../../../resources/css/vuedatepickerui.css'
import CBox from '../../../../../../resources/js/components/ui/CBox'
import CBoxChart from '../components/ui/CBoxChart.vue'
import CBoxTable from '../components/ui/CBoxTable.vue'
import CSpinner from '../../../../../../resources/js/components/ui/CSpinner.vue'
import Datepicker from 'vue-datepicker-ui'
import NoData from '../../../../../../resources/js/components/NoData.vue'
import apiService from '../apiService'
import constants from '../../../../../../resources/js/constants'
import { Notification } from 'uiv'
import { mapGetters, mapMutations, mapState } from 'vuex'
import helpers from '../mixins/helpers'
// import { round } from '../../../../../../resources/js/helper'

export default {
  name: 'Reviews',
  components: { CBox, CBoxChart, CBoxTable, CSpinner, Datepicker, NoData },
  mixins: [helpers],
  data: () => ({
    datepickerPeriod: [], // Период для компонента VueDatePicker
    isChartLoading: true,
    isTableLoading: true,
    isWatchEnabled: false, // Разрешить отслеживание изменений в watches
    period: null, // Период для модели
    region: null, // Регион для модели
    regions: [], // Список регионов для выбора
    searchEngine: null, // ПС для модели
    chart: {
      axisTicksYBeginAtZero: false,
      chartData: {},
      color: '#ef4444',
      height: 320,
      stepY: 0,
      type: 'line'
    }, // Данные для графика
    table: { // Данные таблицы
      header: [],
      body: []
    }
  }),
  computed: {
    ...mapGetters({
      getPeriod: 'serm/period/getPeriod',
      getRegions: 'serm/regions/getRegions'
    }),
    ...mapState({
      domainSelected: state => state.serm.client.domains.selected,
      regionSelected: state => state.serm.regions.selected
    }),
    // Свойства для отслеживания
    watches () {
      return {
        period: this.period,
        region: this.region,
        searchEngine: this.searchEngine
      }
    }
  },
  watch: {
    getPeriod: function (val) {
      if (val) {
        this.period = val
      }
    },
    getRegions: function (val) {
      if (val) {
        this.regions = val
      }
    },
    regionSelected: function (val) {
      if (val) {
        this.region = val
      }
    },
    watches: {
      handler (val) {
        const allowFetchData = Object.values(val).every(x => x !== undefined && x !== null)
        // Если все свойства проинициализированы и активировано отслеживание состояний, делаем нужные запросы
        if (allowFetchData && this.isWatchEnabled) {
          this.fetchAll()
        }
      },
      deep: false,
      immediate: true,
      once: true // Фикс с дублирующимися запросами при генерации события mount
    }
  },
  mounted () {
    // ID региона по умолчанию
    this.region = this.regionSelected
    // Список регионов
    this.regions = this.getRegions
    // ПС по умолчанию - Яндекс
    this.searchEngine = constants.SENGINE_YANDEX
    // Инициализация периода
    this.initPeriod()
    // Подгружаем данные в момент отрисовки страницы (событие mount)
    this.fetchAll()
    // Включаем отслеживание состояний
    const self = this
    self.$nextTick(() => {
      self.enableWatch()
    })
  },
  methods: {
    ...mapMutations({
      setPeriod: 'serm/period/setPeriod'
    }),
    /**
     * Включает отслеживание состояний
     */
    enableWatch () {
      if (!this.isWatchEnabled) {
        this.isWatchEnabled = true
      }
    },
    /**
     * Выполняет запросы к API на получение данных для графика и таблицы
     */
    fetchAll () {
      return Promise.all([
        this.fetchChartData().then(this.onChartsDataResolve),
        this.fetchTableData().then(this.onTableDataResolve)
      ])
    },
    /**
     * Метод-обёртка над запросом к API /api/serm/reviews/query-stats
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchTableData () {
      // this.isTableLoading = true
      return new Promise(resolve => {
        if (this.domainSelected) {
          apiService.getReviewsStatisticsForTable(
            this.domainSelected.url,
            this.period.from.toLocaleDateString('en-CA'), // YYYY-mm-dd
            this.period.to.toLocaleDateString('en-CA'), // YYYY-mm-dd
            this.region,
            this.searchEngine
          )
            .then(response => {
              this.isTableLoading = false
              resolve(response.data)
            })
            .catch(() => {
              this.isTableLoading = false
              Notification.notify.error({
                title: 'Ошибка',
                content: 'Не удалось загрузить информацию по статистике запросов для таблицы.'
              })
            })
        }
      })
    },
    /**
     * Метод-обёртка над запросом к API /api/serm/reviews/chart-stats
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchChartData () {
      // this.isChartLoading = true
      return new Promise(resolve => {
        if (this.domainSelected) {
          apiService.getReviewsStatisticsForChart(
            this.domainSelected.url,
            this.period.from.toLocaleDateString('en-CA'), // YYYY-mm-dd
            this.period.to.toLocaleDateString('en-CA'), // YYYY-mm-dd
            this.region,
            this.searchEngine
          )
            .then(response => {
              this.isChartLoading = false
              resolve(response.data)
            })
            .catch(() => {
              this.isChartLoading = false
              Notification.notify.error({
                title: 'Ошибка',
                content: 'Не удалось загрузить информацию по статистике запросов для графика.'
              })
            })
        }
      })
    },
    initPeriod () {
      this.period = this.getPeriod
      if (!this.period || !this.period.from || !this.period.to) {
        // Период по умолчанию - последние полгода
        this.period = {
          from: new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1),
          to: new Date()
        }
      }
      this.datepickerPeriod = [
        this.period.from,
        this.period.to
      ]
      this.updatePeriod(this.period)
    },
    onTableDataResolve (data) {
      if (this.table.header.length > 0) {
        this.table.header = []
      }
      if (this.table.body.length > 0) {
        this.table.body = []
      }
      this.table.header = [
        { text: 'Запрос' },
        ...data.head.map(item => {
          return { text: item }
        }),
        { text: 'Динамика' }
      ]
      for (const [key, value] of Object.entries(data.body)) {
        this.table.body.push(
          [
            { text: key },
            ...value.map(item => {
              return { text: item.percent }
            }),
            ...value.map(item => {
              return { text: item.diff }
            }).filter((item, key) => {
              if (key === 0) {
                return item
              }
            })
          ]
        )
      }
    },
    onChartsDataResolve (data) {
      this.chart.axisTicksYBeginAtZero = data.min === 0
      this.chart.stepY = this.getStepSize(data.min, data.max, 2)
      const searchEngineNames = {
        g: 'Google',
        y: 'Яндекс'
      }
      // console.log(searchEngineNames[this.searchEngine])
      this.chart.chartData = {
        labels: [searchEngineNames[this.searchEngine]],
        charts: [
          data.data.map(i => ({ date: i[0] * 1000, value: i[1] }))
        ]
      }
    },
    /**
     * Сохраняет новое значение периода в store
     * @param period
     */
    updatePeriod (period) {
      this.setPeriod(period)
    },
    /**
     * Сохраняет новое значение периода из Datepicker в store
     * @param period
     */
    updatePeriodFromDatePicker (period) {
      this.updatePeriod({
        from: period[0],
        to: period[1]
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../resources/css/variables';

.flex-row {
  display: flex;
  margin-left: -5px;
  margin-right: -5px;
  align-items: center;
  flex-wrap: wrap;
  & > .flex-col {
    padding-left: 5px;
    padding-right: 5px;
    @media all and (max-width: $xsBreakpoint - 1) {
      & {
        flex: 1;
        flex-basis: 100%;
      }
    }
    input[type=checkbox], input[type=radio] {
      margin: 0;
      vertical-align: middle;
      & + span {
        padding-left: 5px;
      }
      cursor: pointer;
    }
    .region-select {
      min-width: 200px;
      cursor: pointer;
    }
  }
}
</style>
